import React from 'react'
import _ from 'lodash'
import { Typography } from '@material-ui/core'

import { ConsultStatusIcon } from 'utils/icons'
import serviceStatusConstants from 'utils/constants/serviceStatus'
import analysisStatusConstants from 'utils/constants/analysisStatus'

const PanelTitleRight = ({ services }) => {
  const statuses = [
    {
      status: serviceStatusConstants.SERVICE_STATUS.processing,
      analysisStatus: null,
      count: _.filter(services, { status: serviceStatusConstants.SERVICE_STATUS.processing }).length,
    },
    {
      status: serviceStatusConstants.SERVICE_STATUS.error,
      analysisStatus: null,
      count: _.filter(services, { status: serviceStatusConstants.SERVICE_STATUS.error }).length,
    },
    {
      status: null,
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
      count: _.filter(services, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved }).length,
    },
    {
      status: null,
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.in_attention,
      count: _.filter(services, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.in_attention }).length,
    },
    {
      status: null,
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.reproved,
      count: _.filter(services, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.reproved }).length,
    },
  ]

  const renderStatusIcon = ({ status, analysisStatus, count }) => {
    const doc = {
      status: status,
      analysis_status: analysisStatus,
    }

    if (count === 0) return null

    return (
      <div style={{ display: 'flex', alignItems: 'center', marginLeft: 15 }}>
        <Typography>{count}</Typography>
        <div style={{ paddingLeft: 2 }} />
        <ConsultStatusIcon consult={doc} />
      </div>
    )
  }

  const renderIcons = () => {
    return _.map(statuses, (statusObj) => (
      <div key={statusObj.status || statusObj.analysisStatus}>
        {renderStatusIcon(statusObj)}
      </div>
    ))
  }

  return <div style={{ display: 'flex' }}>{renderIcons()}</div>
}

export default PanelTitleRight
